import * as React from "react";
import PropTypes from 'prop-types';

const SvgNewHambIcon = props => {
  if (props.id !== "_svgnewhambicon") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 10.5A1.5 1.5 0 019.5 9h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 018 10.5zM8 20a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 018 20zm1.5 8a1.5 1.5 0 000 3h21a1.5 1.5 0 000-3h-21z" fill="#202020" /></svg>;
};

SvgNewHambIcon.displayName = "_svgnewhambicon";
SvgNewHambIcon.propTypes = {
  id: PropTypes.string
};
SvgNewHambIcon.defaultProps = {
  id: ''
};
export default SvgNewHambIcon;